import {
  type DefinedPreferences,
  type EntityId,
  type Preference,
  type PreferenceGetInput,
  type PreferenceGetSuccess,
} from '@terros/common'
import { type GetHookResponse } from '../hooks'
import { preferenceKey } from '../keys'
import { useTantalimQuery } from '../query'

export function usePreference<T extends Preference>(
  preference: T,
  targetId?: EntityId
): GetHookResponse<DefinedPreferences<T>> {
  const { data, ...state } = usePreferenceDetail(preference, targetId)
  return { ...state, data: data?.value }
}

export function usePreferenceDetail<T extends Preference>(
  preference: T,
  targetId?: EntityId
): GetHookResponse<PreferenceGetSuccess<T>> {
  return useTantalimQuery<PreferenceGetInput<T>, PreferenceGetSuccess<T>, PreferenceGetSuccess<T>>({
    url: '/preference/get',
    queryKey: preferenceKey(preference, targetId),
    input: { preference, targetId },
    convertResponse: (data) => data,
  })
}
